import { BottomNavigationProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const BottomNavigation = (_props: BottomNavigationProps): null => null;
